import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ClientService } from '../../services/client.service';
import { trigger, transition, style, animate, useAnimation } from '@angular/animations';
import { bounce } from 'ng-animate';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { DeleteConfirmModalComponent } from '../delete-confirm-modal/delete-confirm-modal.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material';


export const FLIP_TRANSITION = [
  trigger(
    'inOutAnimation',
    [
      transition(
        ':enter',
        [
          style({ opacity: 0 }),
          animate('0.5s ease-in-out',
            style({ opacity: 1 }))
        ]
      ),
      transition(
        ':leave',
        [
          style({ opacity: 1 }),
          animate('0s ease-in',
            style({ opacity: 0 }))
        ]
      )
    ]
  ),
  trigger('bounce', [transition('* => *', useAnimation(bounce))]),
];


@Component({
  selector: 'location-tab',
  templateUrl: './location-tab.component.html',
  styleUrls: ['./location-tab.component.scss'],
  animations: [FLIP_TRANSITION]
})

export class LocationTabComponent implements OnInit {
  @Input('isActive') isActive: Boolean;
  @Input('location') location: any;
  @Input('index') locationIndex: any;

  @Output() onDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedLocation: EventEmitter<any> = new EventEmitter<any>();


  editing: boolean = false;
  backupLocation;
  loading: boolean;
  bounce: any;
  loca: any;
  defaultLocation;
  currentUser: any;
  user;
  hide: boolean;
  error: any;
  constructor(private _clientService: ClientService, private router: Router, private activatedRoute: ActivatedRoute, public dialog: MatDialog) {
    // this.activeLocation();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (!this.user.isAdmin) {
      this.hide = true
    }
    // this.location.title
    console.log("Location TAB = ", this.location, this.locationIndex);
    // this.activeLocation();
    this.backupLocation = JSON.parse(JSON.stringify(this.location));
    this.activatedRoute.queryParams.subscribe(qparams => {
      console.log("qparams =====>>>>>", qparams, _.isEmpty(qparams));
      if (_.isEmpty(qparams)) {
        this.activeLocation();
      }
      // if(!qparams['location']){
      //   this.activeLocation();
      // }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.locationIndex && changes.locationIndex.currentValue) {
      this.locationIndex = changes.locationIndex.currentValue
    }
  }
  select() {
    console.log('Selected' + this.isActive);
    // alert("Selected" + this.isActive);
  }
  editLocation() {
    console.log("Enabling Editing")
    this.editing = true;
  }
  updateLocation() {
    this.loading = true;
    let location = {}

    if (this.location.title) location['title'] = this.location.title
    if (this.location.client) location['client'] = this.location.client
    if (this.location._id) location['_id'] = this.location._id


    this._clientService.updateLocation(location).subscribe(updatedLocation => {
      this.location = updatedLocation;
      this.loading = false;
      this.editing = false;
    }, err => {
      console.error(err);
      this.loading = false;
      this.location = this.backupLocation;
      this.editing = false;

    })

  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }
  deleteLocation() {
    this.openDialog(DeleteConfirmModalComponent, 'Location').subscribe(res => {
      if (res == 'yes') {
        console.log("LOCATION DELETING", this.location._id);
        this._clientService.deleteLocation(this.location._id).subscribe(updatedLocation => {
          this.loading = true;
          // this.location = updatedLocation;
          this.loading = false;
          this.editing = false;
          this.onDeleted.emit(this.location._id);
        }, err => {
          console.log('Error while delete:', err);
          this.onDeleted.emit({ error: err.err });
          this.loading = false;
          this.location = this.backupLocation;
          this.editing = false;
        })
      }
    })
  }

  locationDetails(data) {
    this.selectedLocation.emit(data)
  }

  activeLocation() {
    console.log("activeLocation is", this.locationIndex);
    if (this.locationIndex == 0) {
      this.defaultLocation = this.location;
      this.selectedLocation.emit(this.location)
    }
  }
}
